export default __webpack_public_path__ + "static/media/wex_icon.456268fb.png";